import React from "react";
import "./index.css";
import ImageUpload from "../../../layout/ImageUpload/index";
import BgTransformer from "../../../layout/BgTransformer";
import {useSetting} from "../../../contexts/setting";
import {useBgUrl} from "hooks/useBgUrl";

const EmailPhotoWebinar = ({id, zoom}) => {
  const {type} = useSetting();
  const {url: bgUrl} = useBgUrl();
  return (
    <div id={id} className={`template ${type.value}`} style={{"--zoom-level": zoom}}>
      <div className="template-inner">
        <BgTransformer src={bgUrl} id={id} />
        <div className="speaker-photo speaker-photo-1">
          <ImageUpload id="speaker-1" imageKey="speaker-1" transformKey={`${id}-speaker-1`} />
        </div>
        <div className="speaker-photo speaker-photo-2">
          <ImageUpload id="speaker-2" imageKey="speaker-2" transformKey={`${id}-speaker-2`} />
        </div>
      </div>
    </div>
  );
};

export default EmailPhotoWebinar;
